import Vue from 'vue';
import Vuetify from 'vuetify/lib';
//import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        light: true,
        dark: false,
        themes: {
            light: {
                primary: '#00796B',
                topbar: '#00796B',
                sidebar: '#B2DFDB',
                sidebarmenu: '#4DB6AC',
                disabledarrow:'#E0F2F1',
                disabledarrowback:'#B2DFDB',
                accent:'#B2DFDB',
                xx:'#336699',
            },
            dark: {
                primary: '#00796B',
                disabledarrow:'#333333',
            }
        }
    }
});
